import { Outlet } from 'react-router';
import { useTranslation } from 'react-i18next';

import { RedirectWithToast } from '@/shared/ui/RedirectWithToast';
import { useCanEnterAdmin } from './adminAccess';

/**
 * Gate for the `/admin/...` area (ADR 0015). A deep link into franchise administration without
 * any franchise-wide admin permission redirects to `/` (the landing resolver) with a toast,
 * instead of rendering a shell the user cannot use. UX only — the backend 403 on each admin
 * page remains the real boundary (ADR 0007).
 */
export function AdminGuard() {
  const { t } = useTranslation('common');
  const canEnter = useCanEnterAdmin();
  if (!canEnter) {
    return <RedirectWithToast to="/" message={t('admin.forbidden')} />;
  }
  return <Outlet />;
}
